import CustomCard from '../../../core/components/common/custom-cards.component';
import Grid from '@mui/material/Grid';
import { useState,useEffect } from "react";
import { useSnackbar } from "notistack";
import ModuleService from '../services/api/module-service';
import { moduleMenuItemsTemplate } from '../utils/moduleMenuConfig';
import EditModuleModal from './edit-module-modal.component';
import DeleteModuleModal from './delete-module.component';

const PermissionListViewCards = ({recordChange, setRecordChange, onModuleClick }) => {
    const [openEdit, setOpenEdit] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [card, setCard] = useState(null);
    const [cards, setCards] = useState([])
    const { enqueueSnackbar } = useSnackbar();

    const handleRecordChange = () => setRecordChange(true)

    const fetchData = () => {
        ModuleService.listModules().then((res) => {
            let apiResponse = res.data;
            console.log("apiResponse", apiResponse)
            setCards(apiResponse.data)

        }).catch((error) => {
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 2000
            })
        })
    };
          
    // run this function onPageLoad
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(()=>{
        console.log(recordChange)
        if(recordChange) {
            fetchData();
            setRecordChange(false)
        }
    },[recordChange])

    const handleAction = (card, setOpenAction) => {
        setCard(card);
        setOpenAction(true);
    };

    const handleEdit = (card) => { 
        handleAction(card, setOpenEdit);
    };

    const handleDelete = (card) => {
        handleAction(card, setOpenDelete);
    }
    return (
        <div>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                {cards.map((module, index) => {
                    let menuItems = moduleMenuItemsTemplate(handleEdit, handleDelete);
                    return (
                        <Grid size={{ xs: 2, sm: 4, md: 4 }}>
                            <CustomCard
                                module={module}
                                menuItems={menuItems}
                                onClick={() => onModuleClick(module)} // Trigger module click handler
                            />
                        </Grid>
                    )
                    
                })}
                <EditModuleModal module={card} openEdit={openEdit} setOpenEdit={setOpenEdit} handleRecordChange={handleRecordChange}  />
                <DeleteModuleModal module={card} open={openDelete} setOpen={setOpenDelete} handleRecordChange={handleRecordChange} />
            </Grid>
        </div>
    )
}

export default PermissionListViewCards